import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { IccCatalogedDrugImportsService } from 'app/core/services/icc/icc-cataloged-drug-imports.service';
import { ImportUploadResult, IccImportUploadComponent } from '../../components/icc-import-upload/icc-import-upload.component';
import { HttpErrorResponse } from '@angular/common/http';
import { isEmpty } from 'lodash-es';
import { ImportNavComponent } from '../../../shared/components/import-nav/import-nav.component';


@Component({
    selector: 'app-icc-import-cataloged-drugs',
    templateUrl: './icc-import-cataloged-drugs.component.html',
    styleUrls: ['./icc-import-cataloged-drugs.component.scss'],
    imports: [ImportNavComponent, IccImportUploadComponent]
})
export class IccImportCatalogedDrugsComponent {
  private catalogedDrugImportsService = inject(IccCatalogedDrugImportsService);
  private router = inject(Router);

  errors: string[] = [];

  onUploadComplete({ clientId, name, upload }: ImportUploadResult) {
    this.catalogedDrugImportsService.create(clientId, name, upload.signedId).subscribe(
      () => {
        this.router.navigate(['/capture-admin/icc-claims/imports/cataloged-drugs/history']);
      },
      (error: HttpErrorResponse) => {
        this.errors = error.error.errors;
      }
    );
  }

  onUploadStart() {
    this.errors = [];
  }

  public get hasError() {
    return !isEmpty(this.errors);
  }
}
